<template>
  <div>
    <v-card outlined height="100%" width="100%" class="d-flex justify-center" v-if="!finishUpload && !preview">
      <div class="d-flex justify-center items-center">
        <cp-button class="align-self-center" color="primary" @click.prevent="openModal">{{uploadButton}}</cp-button>
      </div>
    </v-card>
    <v-container v-else>
      <v-hover v-slot="{ hover }">
        <v-card>
          <v-avatar
              class="profile"
              color="grey"
              size="100%"
              tile
          >
            <v-img
                v-if="isImageInput"
                :src="preview"
                width="150"
                class="grey darken-4"
            ></v-img>
            <span
              v-else
            >
              {{ preview }}
            </span>
          </v-avatar>
          <v-fade-transition>
            <v-overlay
                v-if="hover"
                absolute
                color="#000"
            >
              <cp-button class="align-self-center px-2" color="primary" @click.prevent="openModal">{{uploadButton}}</cp-button>
            </v-overlay>
          </v-fade-transition>
        </v-card>
      </v-hover>
    </v-container>
    <cp-simple-modal ref="simple-modal" size="large">
      <template #body>
        <v-card
            @drop.prevent="onDrop($event)"
            @dragover.prevent="dragover = true"
            @dragenter.prevent="dragover = true"
            @dragleave.prevent="dragover = false"
            :class="{ 'grey lighten-2': dragover }"
            class="d-flex flex-column justify-center"
            style="height: 350px"
        >
          <v-card-text>
            <!-- New Addition -->
            <v-row class="d-flex flex-column" dense align="center" justify="center">
              <input :multiple="multiple" name="basic_info[logo]" @input="onInput($event)" type="file" style="display: none" ref="fileInput">
              <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']"  @click="openFileInput" class="pointer" size="60">$cloudUpload</v-icon>
              <p>
                Arreste e solte seus arquivos aqui, ou <a href="#" @click="openFileInput">clique aqui</a> para selecioná-los
              </p>
            </v-row>

            <v-virtual-scroll
                v-if="listFiles.length > 0"
                :items="listFiles"
                height="250"
                item-height="80"
            >
              <template v-slot:default="{ item }">
                <v-list-item :key="item.name">
                  <v-list-item-action>
                    <v-avatar rounded="0" height="55">
                      <v-img
                          contain
                          :src="objectUrl(item)"
                      ></v-img>
                    </v-avatar>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn @click.stop="removeFile(item.name)" icon>
                      <v-icon>$closeBox</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

                <v-divider></v-divider>
              </template>
            </v-virtual-scroll>
          </v-card-text>
        </v-card>
      </template>
    </cp-simple-modal>
  </div>
</template>

<script>
import CpSimpleModal from '../pages/support/SimpleModal'

export default {
  name: "File",
  components: {
    CpSimpleModal,
  },
  props: {
    uploadButton: {
      type: String,
      required: false,
      default: 'Carregar arquivo'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    images: {
      type: String|Array,
      required: false
    },
    isImageInput: {
      type: Boolean,
      default: false,
    },
    acceptedMimeTypes: {
      type: Array,
      default: [],
    },
  },
  data: () => ({
    dragover: false,
    finishUpload: false,
    listFiles: [],
    preview: null
  }),
  methods: {
    openFileInput () {
      this.$refs.fileInput.click()
    },
    openModal () {
      let vm = this
      
      this.$refs['simple-modal'].open({
        btnError: false,
        btnSuccess: {
          text: 'Salvar',
          color: 'primary',
          click: (() => {vm.clickSuccess()})
        },
        title: 'Upload de arquivo',
        size: 'large'
      })
    },

    clickSuccess() {
      if (!this.listFiles.length) {
        this.$bus.$emit('feedback', {
          message: 'Nenhum arquivo selecionado',
          type: 'warning',
        })
        return
      }

      if (this.acceptedMimeTypes.length) {
        const invalidFile = this.listFiles.find(file => !this.acceptedMimeTypes.includes(file.type))
        if (invalidFile) {
          this.$bus.$emit('feedback', {
            message: `O tipo do arquivo ${invalidFile.name} não é aceito`,
            type: 'error',
          })
          return
        }
      }

      this.$emit("filesUploaded", this.listFiles);

      if (!this.multiple) {
        //Fazer exibir o preview
        if (this.isImageInput)
          this.preview = this.objectUrl(this.listFiles[0])
        else
          this.preview = this.listFiles[0].name

        this.finishUpload = true
      }
    },

    objectUrl(file) {
      return URL.createObjectURL(file)
    },

    onInput (e) {
      this.pushUploadedFiles(e.target.files)
      //Limpa o input para receber o mesmo arquivo caso remova da lista e selecione novamente
      e.target.value = null
    },

    onDrop (e) {
      this.dragover = false;
      if (!this.multiple && e.dataTransfer.files.length > 1) {
        alert('Você só pode adicionar um arquivo apenas')
      } else {
        this.pushUploadedFiles(e.dataTransfer.files)
      }
    },

    pushUploadedFiles (FileUploaded) {
      Array.from(FileUploaded).forEach(file => {
        if (this.multiple) {
          let has = this.listFiles.find(item => item.name === file.name)
          if (!has) this.listFiles.push(file)
        } else {
          this.listFiles = [file]
        }
      });
    },
    removeFile (fileName) {
      const index = this.listFiles.findIndex(
          file => file.name === fileName
      );
      if (index > -1) {
        this.listFiles.splice(index, 1);
      }
    },
  },
  watch: {
    images (newV) {
      if (typeof newV === 'string' && !this.multiple) {
        this.preview = newV
      }
    }
  }
}
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
